export function orderRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "FETCH_ORDERS_START":                      
        case "VALIDATE_ORDER_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "FETCH_ORDERS_FULFILLED":                      
        case "VALIDATE_ORDER_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "FETCH_ORDERS_ERROR":
        case "VALIDATE_ORDER_ERROR":           
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}